import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    selector: 'app-finzy-bolt-popup',
    templateUrl: './finzy-bolt-popup.component.html',
    styleUrls: ['./finzy-bolt-popup.component.scss']
})

export class FinzyBoltPopupComponent {
    private matDialogRef: MatDialogRef<FinzyBoltPopupComponent>;
    public addMoney: boolean = false;
    public boltEnabled: boolean;
    constructor(
        matDialogRef: MatDialogRef<FinzyBoltPopupComponent>,
        @Inject(MAT_DIALOG_DATA) data: {
            addMoney: boolean,
            boltEnabled: boolean,
        }
    ) {
        this.matDialogRef = matDialogRef;
        this.addMoney = data.addMoney;
        this.boltEnabled = data.boltEnabled;
    }

    onClickClose() {
        return this.matDialogRef.close();
    }

    onClickBoltOff(boltEnabled: boolean) {
        boltEnabled = !boltEnabled;
        return this.matDialogRef.close(boltEnabled);
    }

}